module.exports = __webpack_public_path__ + "static/media/Menu.0d795c29.svg";